import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=3eb85d6e&scoped=true&"
import script from "./Deal.vue?vue&type=script&lang=js&"
export * from "./Deal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb85d6e",
  null
  
)

export default component.exports